// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class UIPositionContainer extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Container) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__UIPositionContainer"] = this;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Container): UIPositionContainer {
    return (gameObject as any)["__UIPositionContainer"];
  }

  private gameObject: Phaser.GameObjects.Container;
  public offsetX: number = 0;
  public offsetY: number = 0;
  public PinLeft: boolean = false;
  public PinRight: boolean = false;
  public PinTop: boolean = false;
  public PinToBottom: boolean = false;
  public IgnoreSize: boolean = false;

  /* START-USER-CODE */
  protected repositionChecks = 0;
  protected repositionFalloff = 200;
  protected repositionMaxFalloff = 5000;

  protected awake() {
    // this.repositionByWindowSize(this.scene.scale.width, this.scene.scale.height, app.Config.sceneWidth, app.Config.sceneHeight);
    this.repositionByCanvasSize(this.scene.scale.width, this.scene.scale.height, this.scene.app.ScaleConfig.sceneWidth, this.scene.app.ScaleConfig.sceneHeight);
    this.scene.scale.on(Phaser.Scale.Events.RESIZE, this.resize, this);
  }

  protected resize(gameSize: Phaser.Structs.Size, baseSize: number, displaySize: number, previousWidth: number, previousHeight: number) {
    // this.repositionByWindowSize(gameSize.width, gameSize.height, app.Config.sceneWidth, app.Config.sceneHeight);
    this.repositionByCanvasSize(gameSize.width, gameSize.height, this.scene.app.ScaleConfig.sceneWidth, this.scene.app.ScaleConfig.sceneHeight);
  }

  protected repositionByWindowSize(width: number, height: number, sceneWidth: number, sceneHeight: number) {
    let canvasBounds = this.scene.game.canvas.getBoundingClientRect();

    // Sometimes the innerHeight is 0 and we don't want to divide by 0, so we just wait until it isn't.
    if (window.innerHeight == 0) {
      this.scene.time.delayedCall(Math.min(this.repositionChecks * this.repositionFalloff, this.repositionMaxFalloff), this.repositionByWindowSize, [width, height], this);
      this.repositionChecks++;
      return;
    }

    let heightMod = sceneHeight / window.innerHeight;

    if (this.PinRight) {
      let right = sceneWidth / 2 + (window.innerWidth * heightMod) / 2;
      right = Math.min(right, sceneWidth);

      if (this.IgnoreSize) this.gameObject.x = right - this.offsetX;
      else this.gameObject.x = right - this.gameObject.getBounds().width / 2 - this.offsetX;
    }

    if (this.PinLeft) {
      let left = sceneWidth / 2 - (window.innerWidth * heightMod) / 2;
      left = Math.max(left, 0);

      if (this.IgnoreSize) this.gameObject.x = left + this.offsetX;
      else this.gameObject.x = left + this.gameObject.getBounds().width / 2 + this.offsetX;
    }

    if (this.PinTop) {
      if (this.IgnoreSize) this.gameObject.y = this.offsetY;
      else this.gameObject.y = this.gameObject.getBounds().height / 2 + this.offsetY;
    }

    if (this.PinToBottom) {
      let top = canvasBounds.bottom;
      top = Math.min(top, canvasBounds.height);

      if (this.IgnoreSize) this.gameObject.y = top * (height / canvasBounds.height) - this.offsetY;
      else this.gameObject.y = top * (height / canvasBounds.height) - (this.gameObject.getBounds().height / 2 + this.offsetY);
    }

    if (isNaN(this.gameObject.x)) this.gameObject.x = 0;
    if (isNaN(this.gameObject.y)) this.gameObject.y = 0;

    this.repositionChecks = 0;
  }

  protected repositionByCanvasSize(canvasWidth: number, canvasHeight: number, sceneWidth: number, sceneHeight: number) {
    let canvasBounds = this.scene.game.canvas.getBoundingClientRect();

    if (this.PinRight) {
      let right = sceneWidth / 2 + canvasWidth / 2;
      // right = Math.min(right, canvasWidth);

      if (this.IgnoreSize) this.gameObject.x = right - this.offsetX;
      else this.gameObject.x = right - this.gameObject.getBounds().width / 2 - this.offsetX;
    }

    if (this.PinLeft) {
      let left = sceneWidth / 2 - canvasWidth / 2;
      // let left = canvasBounds.left;
      left = Math.max(left, 0);

      if (this.IgnoreSize) this.gameObject.x = left + this.offsetX;
      else this.gameObject.x = left + this.gameObject.getBounds().width / 2 + this.offsetX;
    }

    if (this.PinTop) {
      if (this.IgnoreSize) this.gameObject.y = this.offsetY;
      else this.gameObject.y = this.gameObject.getBounds().height / 2 + this.offsetY;
    }

    if (this.PinToBottom) {
      let top = canvasBounds.bottom;
      top = Math.min(top, canvasBounds.height);

      if (this.IgnoreSize) this.gameObject.y = top * (canvasHeight / canvasBounds.height) - this.offsetY;
      else this.gameObject.y = top * (canvasHeight / canvasBounds.height) - (this.gameObject.getBounds().height / 2 + this.offsetY);
    }

    if (isNaN(this.gameObject.x)) this.gameObject.x = 0;
    if (isNaN(this.gameObject.y)) this.gameObject.y = 0;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
